document.addEventListener("DOMContentLoaded", function () {
  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (error) {
      if (error) return console.error('API Fail:', error);

      const banner = document.getElementById('custom-cookie-banner');
      const modal = document.getElementById('privacy-modal');
      
      // Buttons
      const acceptBtn = document.getElementById('accept-cookies-btn');
      const declineBtn = document.getElementById('decline-cookies-btn');
      const openPrefsBtn = document.getElementById('open-preferences-btn');
      const closePrefsBtn = document.getElementById('close-modal-btn');
      const savePrefsBtn = document.getElementById('save-preferences-btn');

      // Checkboxes
      const prefCheck = document.getElementById('consent-preferences');
      const analyticCheck = document.getElementById('consent-analytics');
      const marketCheck = document.getElementById('consent-marketing');

      // 1. Show banner if geotargeting checks out
      if (window.Shopify.customerPrivacy.shouldShowBanner()) {
        banner.style.display = 'block';
      }

      // 2. Accept All Quick-Action
      acceptBtn.addEventListener('click', function () {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { preferences: true, analytics: true, marketing: true },
          () => { banner.style.display = 'none'; }
        );
      });

      // 3. Decline All Quick-Action
      declineBtn.addEventListener('click', function () {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { preferences: false, analytics: false, marketing: false },
          () => { banner.style.display = 'none'; }
        );
      });

      // 4. Modal Open / Close Logic
      openPrefsBtn.addEventListener('click', function () {
        modal.style.display = 'block';
        
        // Optional: Pre-fill current known consent state if they've interacted before
        const currentConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
        prefCheck.checked = currentConsent.preferences === 'yes';
        analyticCheck.checked = currentConsent.analytics === 'yes';
        marketCheck.checked = currentConsent.marketing === 'yes';
      });

      closePrefsBtn.addEventListener('click', function () {
        modal.style.display = 'none';
      });

      // 5. Save Granular Selections
      savePrefsBtn.addEventListener('click', function () {
        const customConsentState = {
          preferences: prefCheck.checked,
          analytics: analyticCheck.checked,
          marketing: marketCheck.checked
        };

        window.Shopify.customerPrivacy.setTrackingConsent(customConsentState, () => {
          modal.style.display = 'none';
          banner.style.display = 'none';
        });
      });
    }
  );
});
